export default "__VITE_ASSET__DPas9FnV__"